<template>
  <div class="uk-container SectionOne">
    <div uk-grid>
      <div class="uk-width-1-2@l uk-width-1-2@m  uk-width-1-1@s DetailsConOne">
        <h1 class="uk-text-center uk-text-middle AppTitle Title" data-aos="zoom-in" data-aos-delay="100">
          Homewind Leisures</h1>
        <p class="uk-text-center Description" data-aos="zoom-in" data-aos-delay="100">
          {{'home_section.para_1'|translate}}
          <br/>
          <br/>
          {{'home_section.para_2'|translate}}
        </p>
      </div>
      <div class="uk-width-1-2@l uk-width-1-2@m  uk-width-1-1@s uk-grid-small" uk-grid>
        <div class="uk-width-2-3@l uk-width-2-3@m uk-width-2-3@s" data-aos="zoom-in">
          <div class="uk-card uk-card-default uk-card-body uk-padding-remove">
            <img :src="`${ASSETS_BASE_URL}/images/home/img_1.jpg`"/>
          </div>
        </div>
        <div class="uk-width-1-3@l  uk-width-1-3@m uk-width-1-3@s" data-aos="zoom-in" data-aos-delay="50">
          <div class="uk-card uk-card-default uk-card-body uk-padding-remove">
            <img :src="`${ASSETS_BASE_URL}/images/home/img_2.jpg`"/>
          </div>
        </div>
        <div class="uk-width-1-2@l  uk-width-1-2@m uk-width-1-2@s" data-aos="zoom-in" data-aos-delay="100">
          <div class="uk-card uk-card-default uk-card-body uk-padding-remove">
            <img :src="`${ASSETS_BASE_URL}/images/home/img_3.jpg`"/>
          </div>
        </div>
        <div class="uk-width-1-2@l  uk-width-1-2@m uk-width-1-2@s" data-aos="zoom-in" data-aos-delay="150">
          <div class="uk-card uk-card-default uk-card-body uk-padding-remove">
            <img :src="`${ASSETS_BASE_URL}/images/home/img_4.jpg`"/>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'HomeSectionOne'
}
</script>

<style scoped>
  .SectionOne {
    padding-top: 70px;
    padding-bottom: 80px;
  }

  .DetailsConOne {
    padding-top: 70px;
  }

  .Title {
    font-family: 'Kaushan Script', cursive !important;
  }

  .Description {
    font-size: 18px;
  }

  @media only screen and (max-width: 959px) {
    .SectionOne {
      padding-top: 20px;
      padding-bottom: 20px;
    }

    .DetailsConOne {
      padding-top: 0;
    }
  }
</style>
